import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "./Components/Layout";
import styles from "./styles/Auth.module.css";
import { api } from "./lib/api";

function getApiErrorMessage(err) {
  const msg =
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.response?.data?.detail ||
    err?.message;

  const status = err?.response?.status;
  if (status && msg) return `${msg} (HTTP ${status})`;
  if (msg) return msg;
  return "Registration failed";
}

/**
 * IMPORTANT:
 * If axios baseURL already ends with "/api", then register path should be "/auth/register".
 * This helper tries that first, then falls back to "/api/auth/register".
 */
async function postAuthRegister(payload) {
  return await api.post("auth/register", payload);
}

export default function Register() {
  const nav = useNavigate();

  const [name, setName] = useState(""); // username -> users.name
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setErr("");

    const n = String(name || "").trim();
    const em = String(email || "").trim().toLowerCase();
    const pw = String(password || "");

    if (!n) return setErr("Username is required");
    if (!em) return setErr("Email is required");
    if (pw.length < 8) return setErr("Password must be at least 8 characters");

    setBusy(true);
    try {
      const { data } = await postAuthRegister({
        name: n,
        email: em,
        password: pw,
      });

      if (!data?.ok) {
        throw new Error(data?.message || data?.error || "Registration failed");
      }

      // ✅ DO NOT auto-login.
      // User must activate via email first.
      nav("/register-success", { replace: true });
    } catch (ex) {
      setErr(getApiErrorMessage(ex));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Layout
      title="Register - My Chinese Horoscope"
      description="Create your account to subscribe"
      keywords="register, signup, subscription"
    >
      <div className={styles.card}>
        <h1>Create account</h1>
        <p className={styles.subtitle}>Then subscribe in one click</p>

        <form onSubmit={onSubmit}>
          <div className={styles.field}>
            <label>Username</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              autoComplete="username"
              required
            />
          </div>

          <div className={styles.field}>
            <label>Email</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              autoComplete="email"
              required
            />
          </div>

          <div className={styles.field}>
            <label>Password</label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              autoComplete="new-password"
              required
              minLength={8}
            />
          </div>

          <div className={styles.actions}>
            <button type="submit" disabled={busy}>
              {busy ? "Creating..." : "Create account"}
            </button>
            <Link to="/login">Already have an account?</Link>
          </div>

          {err && <div className={styles.error}>{err}</div>}
        </form>

    
      </div>
    </Layout>
  );
}
